module.exports = __webpack_public_path__ + "img/icon-arrow-right.1f4a380e.svg";